import React, { Component } from "react";
import ReactImageUploading from "react-images-uploading";
import Resizer from "react-image-file-resizer";
import { create_media } from "../../services/services";

class UploadImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: [],
      pending: false,
    };
  }

  resizeImage(imageList) {
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        imageList[0].file,
        1500,
        1500,
        "JPEG",
        100,
        0,
        (uri) => {
          const formData = new FormData();
          formData.append("file", uri);
          this.setState({ pending: true });
          create_media(formData).then((items) => {
            if (items) {
              var new_images = [];
              if (!this.props.singleMedia) {
                new_images = this.props.images;
              }
              new_images.push(items);
              this.props.updateImages(new_images);
            }
            this.setState({ pending: false });
          });
        },
        "file"
      );
    });
  }

  render() {
    return (
      <ReactImageUploading
        multiple={false}
        value={this.props.images}
        onChange={(imageList, addUpdateIndex) => this.resizeImage(imageList)}
        maxNumber={20}
        dataURLKey="data_url"
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          <section className="row mx-0 px-0">
            <button
              className="btn col-12 p-1"
              style={{ height: "105px" }}
              onClick={onImageUpload}
              disabled={this.state.pending}
            >
              <div className="row mx-0 h-100 text-center bg-light-gray rounded14">
                <div className="col px-0 align-self-center">
                  {this.state.pending ? (
                    <span className="spinner-border spinner-border-sm color-main"></span>
                  ) : (
                    <img
                      alt="camera"
                      className=""
                      src={require("../../assets/icons/camera.svg").default}
                    />
                  )}
                </div>
              </div>
            </button>
          </section>
        )}
      </ReactImageUploading>
    );
  }
}

export default UploadImage;
